import React, { useState } from 'react'

import AddIcon from '@material-ui/icons/Add'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import IconButton from '@material-ui/core/IconButton'
import PropTypes from 'prop-types'
import Switch from '@material-ui/core/Switch'
import TextField from '@material-ui/core/TextField'
import Tooltip from '@material-ui/core/Tooltip'
import {Select, MenuItem, FormHelperText, InputLabel} from '@material-ui/core';

const initial = {
  firstname: '',
  middlename: '',
  surname: '',
  dob: '1970-01-01',
  MRN:'',
  gender: 'M',
  Alias: 'none',
  phoneNo: '+1 (615) 934-6257',
  email: 'missing@email.com',
  local: 'us-en',
  timezone:'EST'
}

const AddDialog = props => {
  const [newItem, setNewItem] = useState(initial)
  const { addHandler } = props
  const [open, setOpen] = React.useState(false)

  const [switchState, setSwitchState] = React.useState({
    addMultiple: false,
  })

  const handleSwitchChange = name => event => {
    setSwitchState({ ...switchState, [name]: event.target.checked })
  }

  const resetSwitch = () => {
    setSwitchState({ addMultiple: false })
  }

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
    resetSwitch()
  }

  const handleAdd = event => {
    addHandler(newItem)
    setNewItem(initial)
    switchState.addMultiple ? setOpen(true) : setOpen(false)
  }

  const handleChange = name => ({ target: { value } }) => {
    setNewItem({ ...newItem, [name]: value })
  }

  const validate = () => {
    if (
      newItem.firstname &&
      newItem.middlename &&
      newItem.surname &&
      newItem.dob &&
      newItem.MRN &&
      newItem.gender
    ) {
      return false;
    } else {
      return true;
    }
  }

  return (
    <div>
      <Tooltip title="Add">
        <IconButton aria-label="add" onClick={handleClickOpen}>
          <AddIcon />
        </IconButton>
      </Tooltip>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Add Patient</DialogTitle>
        <DialogContent>
          <div className="p-3">
          <DialogContentText>All fields are required</DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            label="Firstname"
            type="text"
            fullWidth
            value={newItem.firstname}
            onChange={handleChange('firstname')}
          />
          <TextField
            margin="dense"
            label="Middlename"
            type="text"
            fullWidth
            value={newItem.middlename}
            onChange={handleChange('middlename')}
          /><TextField
            margin="dense"
            label="Lastname"
            type="text"
            fullWidth
            value={newItem.surname}
            onChange={handleChange('surname')}
          />
          <TextField
            margin="dense"
            label="DOB"
            type="text"
            fullWidth
            value={newItem.dob}
            onChange={handleChange('dob')}
          />
           <TextField
            margin="dense"
            label="MRN"
            type="text"
            fullWidth
            value={newItem.MRN}
            onChange={handleChange('MRN')}
          />
          <InputLabel className="mt-4">Gender</InputLabel>
          <Select
              value={newItem.gender}
              onChange={handleChange('gender')}
              displayEmpty
              fullWidth
          >
              <MenuItem value="M">Male</MenuItem>
              <MenuItem value="F">Female</MenuItem>
          </Select>
          {/* <FormHelperText>Add a type for the question here</FormHelperText> */}
          </div>
         </DialogContent>
        <DialogActions>
          <Tooltip title="Add multiple">
            <Switch
              checked={switchState.addMultiple}
              onChange={handleSwitchChange('addMultiple')}
              value="addMultiple"
              inputProps={{ 'aria-label': 'secondary checkbox' }}
            />
          </Tooltip>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleAdd} color="primary" disabled={validate()}>
            Add
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}

AddDialog.propTypes = {
  addHandler: PropTypes.func.isRequired,
}

export default AddDialog
